import { useMutation } from "react-query";
import http from "infra/http";
import { AxiosError } from "axios";

function useDeleteManutencoes() {
  return useMutation<void, AxiosError, string>(
    async (id: string) => {
      await http.delete(`/v1/manutencao/${id}`);
    },
    { retry: false }
  );
}
export default useDeleteManutencoes;
